window.addEventListener('DOMContentLoaded', function () {
  jQuery(function ($) {
    var instance = new Swiper('.coaches-mentors__carousel.swiper', {
      slidesPerView: 1,
      spaceBetween: 16,
      navigation: {
        nextEl: '.coaches-mentors__navigation-wrapper .swiper-button-next',
        prevEl: '.coaches-mentors__navigation-wrapper .swiper-button-prev',
      },
      breakpoints: {
        1280: { slidesPerView: 'auto', slidesPerGroupAuto: true },
      },
    });
  });
});
